// PRD-014 — money + margin-band helpers.
//
// All amounts on the P&L surface are BIGINT cents from the server. These
// helpers format for display only — they never recompute financial values.

export function formatCents(cents, { currency = 'USD', sign = false, decimals = 2 } = {}) {
  const n = (Number(cents) || 0) / 100;
  // PRD-031 F3.1 — `decimals: 0` renders whole-dollar header money. Grid line
  // items and grid footer totals keep Fidelity-grade cents (the default).
  const abs = Math.abs(n).toLocaleString(undefined, {
    style: 'currency', currency, minimumFractionDigits: decimals, maximumFractionDigits: decimals,
  });
  if (n < 0) return `(${abs})`;          // accounting convention for negatives
  return sign ? `+${abs}` : abs;
}

export function formatPct(pct, digits = 1) {
  return `${(Number(pct) || 0).toFixed(digits)}%`;
}

// Margin band per design spec §8.2 (the visual source of truth):
//   ≥ 30% emerald · 15–30% neutral · 0–15% amber · < 0% red
const BANDS = {
  good: '#10b981',
  neutral: '#0f172a',
  caution: '#f59e0b',
  loss: '#ef4444',
};

export function marginBand(pct) {
  const p = Number(pct);
  if (Number.isNaN(p)) return 'neutral';
  if (p < 0) return 'loss';
  if (p < 15) return 'caution';
  if (p < 30) return 'neutral';
  return 'good';
}

export function marginBandColor(pct) {
  return BANDS[marginBand(pct)];
}
